module.exports = __webpack_public_path__ + "img/CrossImage.png";